import React from "react";
import { Footer } from "flowbite-react";
import logo_light from "../assets/images/logo-icon.png";
import { Link } from "react-router-dom";

function AppFooter() {
  const isDevelopment = process.env.NODE_ENV === "development";

  return (
    <Footer className="bg-white dark:bg-slate-900 border-t border-gray-100 dark:border-gray-800">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="flex items-center space-x-2">
            <img src={logo_light} alt="OmniButler" className="h-8 w-8" />
            <span className="text-lg font-semibold">OmniButler</span>
          </div>

          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link
              to="/privacy-policy"
              className="text-sm text-gray-600 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              className="text-sm text-gray-600 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400"
            >
              Terms of Service
            </Link>
            <a
              href="/contact"
              className="text-sm text-gray-600 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400"
            >
              Contact
            </a>
          </div>
        </div>
        <div className="text-center mt-8 text-sm text-gray-500">
          © 2024 OmniButler. All rights reserved.
        </div>
        {isDevelopment && (
          <div className="mt-8 p-4 bg-gray-50 dark:bg-slate-800 rounded-lg overflow-auto">
            <div className="flex justify-between items-center mb-2">
              <span className="font-mono text-sm text-gray-500">
                Debug Info
              </span>
              <span className="px-2 py-1 text-xs bg-yellow-100 text-yellow-800 rounded">
                DEV
              </span>
            </div>
            <pre className="text-xs text-gray-600 dark:text-gray-400">
              <code>{JSON.stringify(process.env, null, 2)}</code>
            </pre>
          </div>
        )}
      </div>
    </Footer>
  );
}

export default AppFooter;
